import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import { useSitecoreJssQuery } from 'omni-package-react-cms';
import { NewsDto } from '../../interfaces/dto/NewsDto';
import transformNewsData from './transformNewsData';

export const NewsResourceInfo: ResourceInfo = {
  name: '/App.features.news.newsResource',
  dataDst: '/App.features.news.list',
};

const NewsResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => {
  const url = useSitecoreJssQuery('/news');
  return (
    <Resource
      url={url}
      {...NewsResourceInfo}
      {...props}
      transformResponse={(newsDto: NewsDto) => transformNewsData(newsDto)}
    />
  );
};

export default NewsResource;
